import { Link as RouterLink } from 'react-router-dom';
import AppButton, { AppButtonProps } from './AppButton';

export type LinkButtonProps = AppButtonProps<typeof RouterLink>;

/** AppButton as a React Router link (supports `to`, `replace`, etc.). */
export default function LinkButton(props: LinkButtonProps) {
  return <AppButton<typeof RouterLink> component={RouterLink} {...props} />;
}
